/* Feremone theme: cart drawer, pack selector, gallery, sticky add to cart, hero video. */
(() => {
  const T = window.theme || {};
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  // ---------- money ----------
  function formatMoney(cents) {
    const fmt = (T.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    const value = (Number(cents) || 0) / 100;
    const delim = (n, decimals, thousands, decimal) => {
      const [int, frac] = n.toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return delim(value, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(value, 2, "'", '.');
        default: return delim(value, 2, ',', '.');
      }
    });
  }
  const moneyShort = (cents) => formatMoney(cents).replace(/[.,]00(?=\D*$)/, '');
  const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');

  const ICON_MINUS = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>';
  const ICON_PLUS = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  const ICON_REFILL = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4m-4 4a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>';

  async function postJSON(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || (T.strings && T.strings.error) || 'Error');
    return data;
  }

  // ---------- cart drawer ----------
  const Cart = {
    drawer: null,
    state: null,
    lastFocus: null,

    init() {
      this.drawer = $('[data-cart-drawer]');
      if (!this.drawer) return;
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-cart-open]')) {
          e.preventDefault();
          this.refresh().then(() => this.open()).catch(() => { window.location.href = T.routes.cart; });
          return;
        }
        if (e.target.closest('[data-cart-close]')) this.close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
      });
      this.drawer.addEventListener('click', (e) => this.onClick(e));
      // Keep the drawer in sync when the page is restored from the back/forward cache.
      window.addEventListener('pageshow', (e) => { if (e.persisted) this.refresh(); });
    },

    isOpen() { return this.drawer.classList.contains('is-open'); },

    open() {
      this.lastFocus = document.activeElement;
      this.drawer.hidden = false;
      void this.drawer.offsetWidth; // apply the closed state first so the slide-in transition runs
      this.drawer.classList.add('is-open');
      document.body.classList.add('cart-open');
      const panel = $('.cart-drawer__panel', this.drawer);
      if (panel) panel.focus({ preventScroll: true });
    },

    close() {
      this.drawer.classList.remove('is-open');
      document.body.classList.remove('cart-open');
      setTimeout(() => { if (!this.isOpen()) this.drawer.hidden = true; }, 350);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    },

    async refresh() {
      const res = await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } });
      this.state = await res.json();
      this.render();
      return this.state;
    },

    async run(fn) {
      this.drawer.classList.add('is-busy');
      try { await fn(); } catch (err) { console.error(err); }
      await this.refresh().catch(() => {});
      this.drawer.classList.remove('is-busy');
    },

    onClick(e) {
      const qty = e.target.closest('[data-qty]');
      if (qty) {
        this.run(() => postJSON(T.routes.cartChange + '.js', { id: qty.dataset.key, quantity: Number(qty.dataset.qty) }));
        return;
      }
      const up = e.target.closest('[data-upgrade]');
      if (up) {
        const u = JSON.parse(up.dataset.upgrade);
        // Subscription carts add one more refill jar to a line; one-time carts swap to the bundle product.
        if (u.change) this.run(() => postJSON(T.routes.cartChange + '.js', u.change));
        else this.run(() => postJSON(T.routes.cartUpdate + '.js', { updates: u }));
      }
    },

    render() {
      const c = this.state;
      if (!c) return;
      $$('[data-cart-count]').forEach((el) => { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
      const label = $('[data-cart-count-label]', this.drawer);
      if (label) label.textContent = '(' + c.item_count + ')';

      const body = $('[data-cart-body]', this.drawer);
      const foot = $('[data-cart-footer]', this.drawer);
      if (!c.items.length) {
        body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>' +
          '<a class="btn btn--primary btn--block" href="' + esc(T.routes.root) + '#shop">Shop Rouge Ember 540</a>';
        foot.hidden = true;
      } else {
        foot.hidden = false;
        body.innerHTML = c.items.map((item) => {
          const imgUrl = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
          let variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-item__variant">' + esc(item.variant_title) + '</p>' : '';
          Object.entries(item.properties || {}).forEach(([k, v]) => {
            if (v && k.charAt(0) !== '_') variant += '<p class="cart-item__variant">' + esc(k) + ': ' + esc(v) + '</p>';
          });
          const plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
          if (plan) variant += '<p class="cart-item__variant cart-item__plan">' + ICON_REFILL + esc(plan.name) + '</p>';
          const was = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
          return (
            '<div class="cart-item">' +
              '<a class="cart-item__img" href="' + esc(item.url) + '">' + (imgUrl ? '<img src="' + esc(sized(imgUrl, 160)) + '" alt="" width="76" height="76" loading="lazy">' : '') + '</a>' +
              '<div>' +
                '<a class="cart-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant +
                '<div class="qty">' +
                  '<button type="button" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">' + ICON_MINUS + '</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-key="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">' + ICON_PLUS + '</button>' +
                '</div>' +
              '</div>' +
              '<div class="cart-item__end">' +
                '<p class="cart-item__price">' + formatMoney(item.final_line_price) + '</p>' + was +
                '<button type="button" class="cart-item__remove" data-key="' + esc(item.key) + '" data-qty="0">Remove</button>' +
              '</div>' +
            '</div>'
          );
        }).join('');
        const sub = $('[data-cart-subtotal]', this.drawer);
        if (sub) sub.textContent = formatMoney(c.total_price);
      }

      const bar = $('[data-ship-bar]', this.drawer);
      const threshold = Number(T.freeShippingThreshold) || 0;
      if (bar) {
        bar.hidden = !c.items.length || threshold <= 0;
        const remaining = threshold - c.total_price;
        $('[data-ship-fill]', bar).style.width = Math.min(100, (c.total_price / threshold) * 100) + '%';
        $('[data-ship-text]', bar).innerHTML = remaining > 0
          ? 'You’re <strong>' + moneyShort(remaining) + '</strong> away from free shipping'
          : '<strong>You’ve unlocked free shipping</strong>';
      }

      this.renderUpsell();
    },

    renderUpsell() {
      const box = $('[data-cart-upsell]', this.drawer);
      const U = T.upsell || {};
      if (!box) return;
      box.hidden = true;
      if (!U.enabled || !U.single || !this.state.items.length) return;

      const qty = (p) => (p ? this.state.items.filter((i) => i.variant_id === p.id).reduce((s, i) => s + i.quantity, 0) : 0);
      const q1 = qty(U.single), q2 = qty(U.two), q3 = qty(U.three);
      const others = this.state.item_count - q1 - q2 - q3;
      // Subscription cart (Penrose-style refills): every jar is its own refill line, so offer one more jar on the same plan.
      const subLines = this.state.items.filter((i) => i.selling_plan_allocation);
      const jars = subLines.reduce((s, i) => s + i.quantity, 0);
      let offer = null;

      if (subLines.length) {
        const line = subLines[subLines.length - 1];
        const each = line.selling_plan_allocation.price;
        const img = line.featured_image && line.featured_image.url ? sized(line.featured_image.url, 200) : line.image;
        if (jars === 1 || jars === 2) {
          offer = {
            img, title: jars === 1 ? 'Make it 2 jars' : 'Make it 3 jars',
            sub: (jars === 1 ? 'Unlock a free gift' : 'Unlock all 3 free gifts') + ' · ' + formatMoney(each) + ' a jar',
            cta: 'Add +' + moneyShort(each),
            updates: { change: { id: line.key, quantity: line.quantity + 1 } },
          };
        }
      } else if (U.two && q1 === 1 && !q2 && !q3) {
        offer = {
          img: U.two.image, title: 'Make it 2 jars',
          sub: formatMoney(U.two.price) + ' total · save ' + moneyShort(U.single.price * 2 - U.two.price),
          cta: 'Upgrade +' + moneyShort(U.two.price - U.single.price),
          updates: { [U.single.id]: 0, [U.two.id]: 1 },
        };
      } else if (U.two && q1 === 2 && !q2 && !q3) {
        offer = {
          img: U.two.image, title: 'Switch to the 2-jar pack',
          sub: 'Same 2 jars for ' + formatMoney(U.two.price),
          cta: 'Save ' + moneyShort(U.single.price * 2 - U.two.price),
          updates: { [U.single.id]: 0, [U.two.id]: 1 },
        };
      } else if (U.three && q2 === 1 && !q1 && !q3) {
        offer = {
          img: U.three.image, title: 'Upgrade to 3 jars',
          sub: formatMoney(U.three.price) + ' total · save ' + moneyShort(U.single.price * 3 - U.three.price),
          cta: 'Upgrade +' + moneyShort(U.three.price - U.two.price),
          updates: { [U.two.id]: 0, [U.three.id]: 1 },
        };
      }
      if (!offer || (!subLines.length && others < 0)) return;

      box.innerHTML =
        (offer.img ? '<img src="' + esc(offer.img) + '" alt="" width="56" height="56" loading="lazy">' : '<span></span>') +
        '<div><p class="upsell__title">' + esc(offer.title) + '</p><p class="upsell__sub">' + esc(offer.sub) + '</p></div>' +
        '<button type="button" class="btn btn--primary btn--sm" data-upgrade="' + esc(JSON.stringify(offer.updates)) + '">' + esc(offer.cta) + '</button>';
      box.hidden = false;
    },
  };

  // ---------- delivery estimate (business days from today) ----------
  function addBusinessDays(from, days) {
    const d = new Date(from);
    let left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) left -= 1;
    }
    return d;
  }
  const monthDay = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  // 'Oct 15–21', or 'Oct 29 – Nov 4' across months.
  const dateRange = (a, b) => (a.getMonth() === b.getMonth() ? monthDay(a) + '–' + b.getDate() : monthDay(a) + ' – ' + monthDay(b));

  // ---------- "Choose your scent" sheet: bottom sheet on phones, centered box on desktop ----------
  // Built once and filled from the jar's hidden <select>, so picking a row just changes that select.
  const ICON_CHECK = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5L20 7"/></svg>';
  const ICON_CLOSE = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  const ScentSheet = {
    el: null,
    sel: null,
    opener: null,

    build() {
      const el = document.createElement('div');
      el.className = 'scent-sheet';
      el.hidden = true;
      el.innerHTML =
        '<div class="scent-sheet__overlay" data-sheet-close></div>' +
        '<div class="scent-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="ScentSheetTitle">' +
        '<div class="scent-sheet__head"><p class="scent-sheet__title" id="ScentSheetTitle">Choose your scent</p>' +
        '<span class="scent-sheet__jar" data-sheet-jar></span>' +
        '<button type="button" class="scent-sheet__close" aria-label="Close" data-sheet-close>' + ICON_CLOSE + '</button></div>' +
        '<div class="scent-sheet__list" role="listbox" aria-labelledby="ScentSheetTitle" data-sheet-list></div></div>';
      document.body.appendChild(el);
      el.addEventListener('click', (e) => {
        if (e.target.closest('[data-sheet-close]')) { this.close(); return; }
        const opt = e.target.closest('[data-sheet-opt]');
        if (opt && !opt.disabled) this.pick(Number(opt.dataset.sheetOpt));
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
      });
      this.el = el;
    },

    isOpen() { return !!this.el && this.el.classList.contains('is-open'); },

    open(sel, opener, jarLabel) {
      if (!this.el) this.build();
      this.sel = sel;
      this.opener = opener;
      $('[data-sheet-jar]', this.el).textContent = jarLabel || '';
      const list = $('[data-sheet-list]', this.el);
      list.innerHTML = Array.from(sel.options).map((o, i) => {
        if (!o.dataset.variant) return ''; // "More scents coming soon"
        const on = i === sel.selectedIndex;
        const name = o.dataset.title || o.textContent.trim();
        return (
          '<button type="button" class="scent-opt' + (on ? ' is-selected' : '') + '" role="option" aria-selected="' + on + '" data-sheet-opt="' + i + '"' + (o.disabled ? ' disabled' : '') + '>' +
          '<span class="scent-opt__img">' + (o.dataset.img ? '<img src="' + esc(o.dataset.img) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span>' +
          '<span class="scent-opt__text"><span class="scent-opt__top"><span class="scent-opt__name">' + esc(name) + '</span>' +
          (o.disabled ? '<span class="scent-opt__badge scent-opt__badge--out">Sold out</span>' : o.dataset.badge ? '<span class="scent-opt__badge">' + esc(o.dataset.badge) + '</span>' : '') +
          '</span>' +
          (o.dataset.smells ? '<span class="scent-opt__notes">Smells like <strong>' + esc(o.dataset.smells) + '</strong></span>' : '') +
          '</span><span class="scent-opt__check">' + ICON_CHECK + '</span></button>'
        );
      }).join('');
      this.el.hidden = false;
      void this.el.offsetWidth; // apply the closed state first so the slide-in transition runs
      this.el.classList.add('is-open');
      document.body.classList.add('sheet-open');
      const cur = $('.scent-opt.is-selected', list) || $('.scent-opt', list);
      if (cur) {
        cur.scrollIntoView({ block: 'nearest' });
        cur.focus({ preventScroll: true });
      }
    },

    pick(i) {
      const sel = this.sel;
      if (sel && sel.selectedIndex !== i) {
        sel.selectedIndex = i;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.close();
    },

    close() {
      if (!this.isOpen()) return;
      this.el.classList.remove('is-open');
      document.body.classList.remove('sheet-open');
      setTimeout(() => { if (!this.isOpen()) this.el.hidden = true; }, 320);
      if (this.opener) this.opener.focus({ preventScroll: true });
    },
  };

  // ---------- buy box: packs, scent per jar, gifts, subtotal, ajax add ----------
  function initBuyForms(root = document) {
    $$('[data-buy-form]', root).forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      const box = form.closest('[data-buy-box]') || form;
      const input = $('[data-variant-input]', form);
      const planInput = $('[data-plan-input]', form);
      const refillPrice = $('[data-refill-price]', form);
      const atc = $('[data-atc]', form);
      const atcLabel = $('[data-atc-label]', form);
      const atcText = atc ? atc.dataset.atcText : '';
      const packs = $$('[data-pack]', form);
      const multiScent = Number(form.dataset.scentCount) > 1;
      const gifts = $$('[data-gift]', form);
      const giftsTitle = $('[data-gifts-title]', form);
      const giftsNote = $('[data-gifts-note]', form);
      const subCompare = $('[data-subtotal-compare]', form);
      const subPrice = $('[data-subtotal-price]', form);
      const subSave = $('[data-subtotal-save]', form);
      const subSaveAmt = $('[data-subtotal-save-amount]', form);
      const eta = $('[data-eta]', box);
      const etaShip = eta && $('[data-eta-ship]', eta);
      // The sticky bar belongs to the product page form only.
      // getAttribute: form.id would return the form's <input name="id"> (named-property shadowing), not its id.
      const stickyBtn = $('[data-sticky-submit="' + form.getAttribute('id') + '"]');
      const stickyPrice = stickyBtn ? $('[data-sticky-price]') : null;
      // Scent picked for each jar, kept when switching packs.
      const chosen = {};

      const current = () => packs.find((p) => p.checked || p.hasAttribute('data-fixed'));
      const cardOf = (p) => p.closest('[data-pack-card]');

      const showScent = (sel) => {
        const opt = sel.options[sel.selectedIndex];
        const row = sel.closest('.scent');
        if (!opt || !row) return;
        const name = $('[data-scent-name]', row);
        const notes = $('[data-scent-notes]', row);
        const img = $('[data-scent-img]', row);
        if (name) name.textContent = opt.dataset.title || opt.textContent;
        if (notes) notes.innerHTML = opt.dataset.smells ? 'Smells like <strong>' + esc(opt.dataset.smells) + '</strong>' : esc(opt.dataset.notes || '');
        if (img && opt.dataset.img) img.src = opt.dataset.img;
      };

      const update = () => {
        const r = current();
        if (!r) return;
        const n = Number(r.dataset.pack);
        packs.forEach((p) => { const c = cardOf(p); if (c) c.classList.toggle('is-selected', p === r); });
        // Carry scent choices over to the newly selected pack.
        $$('[data-scent-select]', cardOf(r)).forEach((sel) => {
          const v = chosen[sel.dataset.jar];
          if (v != null && sel.value !== v) { sel.value = v; showScent(sel); }
        });
        input.value = r.value;
        // Each pack carries its own refill plan id (empty when subscriptions are off).
        if (planInput) { planInput.value = r.dataset.plan || ''; planInput.disabled = !r.dataset.plan; }
        const price = Number(r.dataset.price);
        if (refillPrice) refillPrice.textContent = formatMoney(price);
        const compare = Number(r.dataset.compare) || 0;
        const available = r.dataset.available === 'true';

        if (subPrice) subPrice.textContent = moneyShort(price);
        const saving = compare > price ? compare - price : 0;
        if (subCompare) { subCompare.hidden = !saving; subCompare.textContent = moneyShort(compare); }
        if (subSave) { subSave.hidden = !saving; if (subSaveAmt) subSaveAmt.textContent = moneyShort(saving); }
        if (stickyPrice) stickyPrice.textContent = formatMoney(price);
        if (atc) {
          atc.disabled = !available;
          if (atcLabel) atcLabel.textContent = available ? atcText : T.strings.soldOut;
        }

        let unlocked = 0;
        let nextAt = 0;
        gifts.forEach((g) => {
          const at = Number(g.dataset.unlock) || 0;
          const on = at <= n;
          g.classList.toggle('is-unlocked', on);
          if (on) unlocked += 1;
          else if (!nextAt || at < nextAt) nextAt = at;
        });
        if (giftsTitle) giftsTitle.textContent = unlocked ? 'Gifts unlocked' : 'Unlock free gifts';
        if (giftsNote) {
          const locked = gifts.length - unlocked;
          const soon = gifts.filter((g) => (Number(g.dataset.unlock) || 0) === nextAt).length;
          giftsNote.textContent = !locked
            ? 'All ' + gifts.length + ' gifts unlocked with this order.'
            : 'Choose ' + nextAt + ' jars to unlock ' + (soon === 1 ? '1 more gift.' : soon + ' more gifts.');
        }

        if (etaShip) {
          const th = Number(eta.dataset.threshold) || 0;
          const free = th && price >= th;
          etaShip.textContent = free ? 'Free shipping unlocked on this order' : 'Free shipping on orders ' + moneyShort(th) + '+';
          etaShip.classList.toggle('is-locked', !free);
        }
      };

      packs.forEach((p) => p.addEventListener('change', update));
      // Each jar row opens the "Choose your scent" sheet instead of the native dropdown.
      $$('[data-scent-row]', form).forEach((row) => {
        const sel = $('[data-scent-select]', row);
        if (!sel || Array.from(sel.options).filter((o) => o.dataset.variant).length < 2) return;
        row.classList.add('scent--sheet');
        row.setAttribute('role', 'button');
        row.setAttribute('aria-haspopup', 'dialog');
        row.tabIndex = 0;
        sel.tabIndex = -1;
        const jars = $$('[data-scent-select]', row.closest('.pack__jars') || form).length;
        const open = () => ScentSheet.open(sel, row, jars > 1 ? 'Jar ' + sel.dataset.jar : '');
        row.addEventListener('click', open);
        row.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
        });
      });
      $$('[data-scent-select]', form).forEach((sel) => sel.addEventListener('change', () => {
        chosen[sel.dataset.jar] = sel.value;
        showScent(sel);
      }));
      if (packs.length) update();

      if (eta) {
        const now = new Date();
        const min = Number(eta.dataset.min) || 0;
        const max = Number(eta.dataset.max) || 0;
        const out = $('[data-eta-dates]', eta);
        if (out && max) out.textContent = dateRange(addBusinessDays(now, min), addBusinessDays(now, max));
      }

      form.addEventListener('submit', async (e) => {
        if (!Cart.drawer) return; // fall back to a normal form post
        e.preventDefault();
        const r = current();
        const n = r ? Number(r.dataset.pack) : 1;
        const sels = r ? $$('[data-scent-select]', cardOf(r)) : [];
        const item = { id: Number(input.value), quantity: 1 };
        const plan = planInput && !planInput.disabled && planInput.value ? Number(planInput.value) : 0;
        let items = [item];
        if (plan) {
          // Subscriptions (Penrose-style): one refill line per jar, in the scent picked for that jar.
          const byVariant = {};
          (sels.length ? sels : [null]).forEach((sel) => {
            const opt = sel ? sel.options[sel.selectedIndex] : null;
            const id = opt && opt.dataset.variant ? Number(opt.dataset.variant) : Number(input.value);
            byVariant[id] = (byVariant[id] || 0) + 1;
          });
          items = Object.entries(byVariant).map(([id, q]) => ({ id: Number(id), quantity: q, selling_plan: plan }));
        } else if (n === 1 && sels[0]) {
          // A single jar is the chosen scent's own product.
          const opt = sels[0].options[sels[0].selectedIndex];
          if (opt && opt.dataset.variant) item.id = Number(opt.dataset.variant);
        } else if (multiScent && sels.length) {
          item.properties = {};
          sels.forEach((sel, i) => {
            const opt = sel.options[sel.selectedIndex];
            item.properties['Jar ' + (i + 1)] = opt ? opt.dataset.title || opt.textContent.trim() : '';
          });
        }
        const err = $('[data-form-error]', form);
        if (err) err.hidden = true;
        const prev = atcLabel ? atcLabel.textContent : '';
        atc.disabled = true;
        atc.classList.add('is-loading');
        if (atcLabel) atcLabel.textContent = T.strings.adding;
        try {
          await postJSON(T.routes.cartAdd + '.js', { items });
          await Cart.refresh();
          Cart.open();
        } catch (ex) {
          if (err) { err.textContent = ex.message; err.hidden = false; }
        } finally {
          atc.disabled = false;
          atc.classList.remove('is-loading');
          if (atcLabel) atcLabel.textContent = prev;
        }
      });
    });
  }

  // ---------- gallery ----------
  function initGalleries(root = document) {
    $$('[data-gallery]', root).forEach((g) => {
      const track = $('[data-gallery-track]', g);
      const thumbs = $$('[data-gallery-thumb]', g);
      if (!track || !thumbs.length) return;
      thumbs.forEach((t) => t.addEventListener('click', () => {
        const slide = track.children[Number(t.dataset.galleryThumb)];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }));
      let raf = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
        });
      }, { passive: true });
    });
  }

  // ---------- sticky add to cart ----------
  function initSticky() {
    const bar = $('[data-sticky-atc]');
    if (!bar) return;
    const btn = $('[data-sticky-submit]', bar);
    const form = btn && document.getElementById(btn.dataset.stickySubmit);
    const atc = form && $('[data-atc]', form);
    if (!form || !atc) return;
    btn.addEventListener('click', () => (form.requestSubmit ? form.requestSubmit() : form.submit()));
    const footer = $('.site-footer');
    // Show once the main button has scrolled above the viewport; hide again over the footer.
    const sync = () => {
      const pastAtc = atc.getBoundingClientRect().bottom < 0;
      const footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      const show = pastAtc && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      btn.tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  // ---------- hero video (loads after the page so the image stays the LCP) ----------
  function initHeroVideo(root = document) {
    $$('[data-hero-video]', root).forEach((v) => {
      if (v.dataset.ready) return;
      v.dataset.ready = '1';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const src = window.matchMedia('(max-width: 749px)').matches ? v.dataset.srcMobile : v.dataset.src;
      if (!src) return;
      const tryPlay = () => {
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      };
      const start = () => {
        v.autoplay = true;
        v.src = src;
        v.addEventListener('playing', () => v.classList.add('is-playing'), { once: true });
        v.addEventListener('canplay', tryPlay, { once: true });
        // Browsers hold autoplay in background tabs; start once the tab is shown.
        document.addEventListener('visibilitychange', () => { if (!document.hidden && v.paused) tryPlay(); });
        tryPlay();
      };
      if (document.readyState === 'complete') setTimeout(start, 150);
      else window.addEventListener('load', () => setTimeout(start, 150), { once: true });
    });
  }

  // ---------- video row: play muted while on screen, tap the speaker to unmute ----------
  function initReels(root = document) {
    $$('[data-reel]', root).forEach((reel) => {
      if (reel.dataset.ready) return;
      reel.dataset.ready = '1';
      const videos = $$('[data-reel-video]', reel);
      const load = (v) => { if (!v.src && v.dataset.src) v.src = v.dataset.src; };
      const play = (v) => { load(v); const p = v.play(); if (p && p.catch) p.catch(() => {}); };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => (e.isIntersecting ? play(e.target) : e.target.pause()));
        }, { threshold: 0.6 });
        videos.forEach((v) => io.observe(v));
      } else {
        videos.forEach(play);
      }
      $$('[data-reel-sound]', reel).forEach((btn) => btn.addEventListener('click', () => {
        const item = btn.closest('.reel__item');
        const v = $('[data-reel-video]', item);
        const unmute = v.muted;
        videos.forEach((o) => { o.muted = true; o.closest('.reel__item').classList.remove('is-unmuted'); });
        v.muted = !unmute;
        item.classList.toggle('is-unmuted', unmute);
        btn.setAttribute('aria-label', unmute ? 'Turn sound off' : 'Turn sound on');
        if (unmute) play(v);
      }));
    });
  }

  // ---------- reviews: show more ----------
  function initReviews(root = document) {
    $$('[data-rv-show]', root).forEach((btn) => btn.addEventListener('click', () => {
      const list = btn.closest('[data-rv-list]');
      $$('[data-rv-more]', list).forEach((el) => { el.hidden = false; });
      btn.closest('.section-cta').remove();
    }));
  }

  // ---------- announcement rotation ----------
  function initAnnouncement() {
    const msgs = $$('[data-announcement] .announcement__msg');
    if (msgs.length < 2) return;
    let i = 0;
    setInterval(() => {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4200);
  }

  // ---------- mobile nav ----------
  function initMobileNav() {
    const nav = $('[data-mobile-nav]');
    if (!nav) return;
    $$('a', nav).forEach((a) => a.addEventListener('click', () => { nav.open = false; }));
    document.addEventListener('click', (e) => { if (nav.open && !nav.contains(e.target)) nav.open = false; });
  }

  // ---------- subscriptions: menu note + "Manage subscription" footer link (Penrose-style) ----------
  // T.subs is true once the main product has a selling plan (layout/theme.liquid).
  function initSubscriptions() {
    if (!T.subs) return;
    const panel = $('.mobile-nav__panel');
    if (panel && !$('.sub-note', panel)) {
      const note = document.createElement('p');
      note.className = 'sub-note';
      note.innerHTML = ICON_REFILL + '<span><strong>Every scent is a subscription</strong>20% off retail, delivered every month. Pause or cancel anytime.</span>';
      panel.insertBefore(note, panel.firstChild);
    }
    const links = $$('.site-footer__links');
    const help = links[links.length - 1];
    if (help && T.routes.account && !$('[data-manage-sub]', help)) {
      const li = document.createElement('li');
      li.innerHTML = '<a href="' + esc(T.routes.account) + '" data-manage-sub>Manage subscription</a>';
      help.insertBefore(li, help.firstChild);
    }
  }

  function init() {
    initSubscriptions();
    Cart.init();
    initBuyForms();
    initGalleries();
    initSticky();
    initHeroVideo();
    initReels();
    initReviews();
    initAnnouncement();
    initMobileNav();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-run section scripts when a section is re-rendered.
  document.addEventListener('shopify:section:load', (e) => {
    initBuyForms(e.target);
    initGalleries(e.target);
    initHeroVideo(e.target);
    initReels(e.target);
    initReviews(e.target);
  });
})();
